import Highcharts from "./highcharts_config";

document.addEventListener("turbolinks:load", () => {
  // Charts
  const special_labels = {
    'On Site': 'On-Site'
  }
  const colors = [
    "#55B5A7",
    "#B035CD",
    "#C084FC",
    "#4BA2E3",
  ]
  const chartsContainer = document.getElementById("charts-container");
  if(!chartsContainer) return;

  // TODO: Looks like chart is configured with a different style
  // this value was meant to be used, but that breaks the charts
  const localityMaxValue = chartsContainer.dataset.localityMaxValue;
  $(".locality-chart").each((i, node) => {
    const data = $(node).data("chart")

    Highcharts.chart(node.id, {
      credits: {
        enabled: false,
      },
      chart: {
        type: "column"
      },
      title: {
        text: data.name,
        align: "left",
        margin: 30,
        style: {
          fontWeight: "bold"
        }
      },
      xAxis: {
        categories: data.categories,
        title: {
          text: "Week",
        },
        style: {
          marginTop: 20
        }
      },
      yAxis: {
        min: 0,
        // TODO: Looks like chart is configured with a different style
        // It is probably ok having this but can do that latter
        // max: parseInt(localityMaxValue),
        title: {
          text: "Personnel",
        },
        // plotLines: [{
        //   dashStyle: "Dot",
        //   value: data.one_response_per_day_line,
        //   color: "#666",
        //   label: {
        //     text: "1 response/person/day",
        //   },
        // }],
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: "bold",
            color: ( // theme
              Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color
            ) || "gray"
          }
        }
      },
      legend: {
        // enabled: false,
        align: "right",
        x: 0,
        verticalAlign: "top",
        y: 40,
        floating: true,
        backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || "white",
        borderColor: "#CCC",
        borderWidth: 1,
        shadow: false
      },
      tooltip: {
        backgroundColor: "#000",
        borderColor: "#000",
        borderRadius: 15,
        style: {
          color: "#fff",
        },
        headerFormat: "<b>Week {point.x}</b><br/><br/>",
        pointFormat: "{series.name}: {point.y:,.0f}<br/>Total: {point.stackTotal}",
      },
      plotOptions: {
        column: {
          borderWidth: 1,
          stacking: "normal",
          dataLabels: {
            enabled: false
          }
        }
      },
      series: data.series.map((series, i) => {
        if(series.name in special_labels){
          series.name = special_labels[series.name]
        }
        series.color = colors[i]
        series.borderColor = colors[i]
        return series
      })
    })
  })
})
